import { AuthenticationService } from './../../../../lib/ng2-sapmp/src/providers/authentication.service';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { AppleCertificateService } from './../shared/apple-cerificate.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { isString } from 'util';


@Component({
  selector: 'app-apple-certificate-upload',
  templateUrl: './apple-certificate-upload.component.html',
  styleUrls: ['./apple-certificate-upload.component.scss'],
  providers: [AppleCertificateService, AdobeAnalyticsService]
})
export class AppleCertificateUploadComponent implements OnInit {
  appleRenewal: boolean = false;
  fileName: string;
  fileString: string;
  pageContent: any;
  appleInfo: any;
  inValidfiletype = false;
  notiContent: any;
  isDisabled: any = false;
  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private appleCertificateService: AppleCertificateService,
    private utilityService: UtilityService,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private authenticationService: AuthenticationService) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.appleInfo = this.appleCertificateService.getAppleInfo();
    if (!this.appleInfo) {
      this.router.navigate(['appleCertificate/info']);
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.fileName = '';
    this.fileString = '';
    this.notiContent = { type: '', content: '' };
    this.appleRenewal = JSON.parse(sessionStorage.getItem('appleRenewal'));
    // // this.appleCertificateService.pageContent(this.utilityService.getEnvConfig().contentUrl.applecertificate.upload).
    //   subscribe(respobj => {
    this.pageContent = this.route.snapshot.data.pageData.appleCertificateupload;
    // this.pageContent = respobj;
    if (isString(this.pageContent.subdescription.download))
      this.pageContent.subdescription.download =
        this.pageContent.subdescription.download.replace('<appleId>', this.authenticationService.getUser().emailAddress);
    for (const i in this.pageContent.subdescription) {
      if (i && isString(this.pageContent.subdescription[i])) {
        this.pageContent.subdescription[i] = this.pageContent.subdescription[i].split(/[[\]]/);
      }
    }
    this.pageloaderService.setPageLoaderStatus(true);
    // });
    this.appleCertificateService.createPageLoadProperties('UPLOAD', 'upload');

  }

  handleFileUpload(evt) {
    const files = evt.target.files;
    const file = files[0];
    if (file.name.indexOf('.pem') === -1) {
      this.fileName = '';
      this.inValidfiletype = true;
      return;
    }
    this.inValidfiletype = false;
    this.fileName = file.name;
    const instanc = this;
    if (files && file) {
      const reader = new FileReader();
      reader.onload = () => {
        var text = reader.result;
        instanc.fileString = btoa(text.toString());
      }
      reader.readAsText(file);
      // ie browser doesn't support readAsBinaryString() alternative - readAsArrayBuffer method
      // reader.readAsArrayBuffer(file);
    }
  }

  downloadCSR() {
    if (!this.utilityService.getEnvConfig().useMock) {
      this.appleCertificateService.downloadCSR(sessionStorage.getItem("appleRenewal")).
        subscribe(respobj2 => {

          // IE doesn't support download attribute used msSaveOrOpenBlob
          const newBlob = new Blob([atob(respobj2.signedcsr)], { type: 'text/plain' });
          let newVariable: any = window.navigator;
          if (newVariable.msSaveOrOpenBlob) {
            newVariable.msSaveOrOpenBlob(newBlob, 'apple.csr');
            return;
          }

          const link = document.createElement('a');
          link.download = 'apple.csr';
          link.href = this.appleCertificateService.makeCSRFile(atob(respobj2.signedcsr));
          document.body.appendChild(link);
          link.click();
        }, error => {
          this.notiContent = { type: 'error', content: 'downloadFailed' };
          this.pageloaderService.setPageLoaderStatus(true);
        });
    }
  }

  uploadAppleCertificate() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formSubmit',
      'BC_Device_Apple_Certificate_UploadFile_Submit', 'success', 'Success_Admit', 'Submit', 'Body',
      '/businessconsole/appleCertificate/info');
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const csrSecurityCheck = (impersonator && impersonator.id) ? true : false;
    if (this.utilityService.getEnvConfig().useMock) {
      sessionStorage.setItem('AppleCertificateUploaded', '1');
      if (!csrSecurityCheck) {
        this.router.navigate(['appleCertificate/info']);
      } else {
        this.pageloaderService.setPageLoaderStatus(true);
        this.isDisabled = true;
      }
      this.appleCertificateService.removeAppleInfo();
      this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formResponse',
        'BC_Device_Apple_Certificate_UploadFile_Submit', 'success', 'Success_Admit', 'Submit', 'Body',
        '/businessconsole/appleCertificate/info');
    } else if (!this.utilityService.getEnvConfig().useMock && !csrSecurityCheck) {
      this.appleCertificateService.uploadAppleCertficate(this.fileString, sessionStorage.getItem("appleRenewal")).subscribe(respobj => {
        // Adobe Analytics Starts
        this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formResponse',
          'BC_Device_Apple_Certificate_UploadFile_Submit', 'success', 'Success_Admit',
          'Submit', 'Body', '/businessconsole/appleCertificate/info');
        // Ends
        sessionStorage.setItem('AppleCertificateUploaded', '1');
        this.router.navigate(['appleCertificate/info']);
        this.appleCertificateService.removeAppleInfo();
      }, error => {
        // Adobe Analytics Error Type Starts
        this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'FAILURE', 'formResponse',
          'BC_Device_Apple_Certificate_UploadFile_Submit', 'Unable to upload Apple Certificate file at this time. Please try again later',
          'Failure_User', 'Submit', 'Body', '/businessconsole/appleCertificate/upload');
        // Ends
        this.notiContent = { type: 'error', content: 'apiError' };
        this.pageloaderService.setPageLoaderStatus(true);
      });
    }
  }

  navigateToStepOne() {
    this.router.navigate(['appleCertificate/info']);
  }
}
